export enum ENumberErrorMessages {
  Max = 'Значение не может быть более 2,1 млрд',
  Required = 'Введите корректное значение',
}
